export const adminRoles = ["admin", "sub-admin", "analyst"];

const roleAccess = {
  admin: ["*"],
  "sub-admin": [
    "/index",
    "/merchants",
    "/platform-feedback",
    "/payments-reports",
    "/subscription-requests",
  ],
  analyst: ["/index"],
};

const extractParams = (template, actual) => {
  if (typeof template !== "string" || typeof actual !== "string") return null;

  const templateParts = template.split("/").filter(Boolean);
  const actualParts = actual.split("/").filter(Boolean);

  if (templateParts.length !== actualParts.length) return null;

  const params = {};

  for (let i = 0; i < templateParts.length; i++) {
    const tPart = templateParts[i];
    const aPart = actualParts[i];

    if (tPart.startsWith(":")) {
      const paramName = tPart.slice(1);
      params[paramName] = aPart;
    } else if (tPart !== aPart) {
      return null;
    }
  }
  return params;
};

const matchPathTemplate = (template, actual) => {
  if (typeof template !== "string") return template === actual;
  return extractParams(template, actual) !== null;
};

function findPermissionByPath(permissionObj, targetPath) {
  if (!permissionObj || typeof permissionObj !== "object") return null;

  if (matchPathTemplate(permissionObj.path, targetPath)) {
    return permissionObj;
  }

  for (const key in permissionObj) {
    if (permissionObj.hasOwnProperty(key)) {
      const value = permissionObj[key];

      if (Array.isArray(value)) {
        for (const item of value) {
          const found = findPermissionByPath(item, targetPath);
          if (found) return found;
        }
      } else if (typeof value === "object" && value !== null) {
        const found = findPermissionByPath(value, targetPath);
        if (found) return found;
      }
    }
  }

  return null;
}

export const getFilteredRoutes = ({
  routes,
  user,
  sidebar = false,
  permissions = null,
}) => {
  const layout = adminRoles.includes(user.role) ? "super-admin" : "admin";

  const checkSubscription =
    user?.type === "restaurant" && user?.subScriptionStatus !== "subscribe";

  return routes
    .filter((route) => {
      const matchesLayout = Array.isArray(route.layout)
        ? route.layout.includes(layout)
        : route.layout === layout;

      if ((sidebar && !route.isMenu) || !matchesLayout) return false;

      if (checkSubscription) {
        return route.path === "/subscriptions";
      }

      if (layout === "super-admin") {
        const allowedPaths = roleAccess[user.role] || [];
        if (!allowedPaths.includes("*") && !allowedPaths.includes(route.path)) {
          return false;
        }
      }

      if (permissions) {
        const matchedPermission = findPermissionByPath(permissions, route.path);
        if (!matchedPermission || !matchedPermission.active) {
          return false;
        }
      }

      return true;
    })
    .map((route) => ({
      ...route,
      path: `/${layout}${route.path}`,
    }));
};
